import { render, staticRenderFns } from "./AppSideNavigation.vue?vue&type=template&id=85837568&"
import script from "./AppSideNavigation.vue?vue&type=script&lang=js&"
export * from "./AppSideNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppSideNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85837568')) {
      api.createRecord('85837568', component.options)
    } else {
      api.reload('85837568', component.options)
    }
    module.hot.accept("./AppSideNavigation.vue?vue&type=template&id=85837568&", function () {
      api.rerender('85837568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppSideNavigation.vue"
export default component.exports